/*
 * Saas banners only show info about:
  * - site usage (for billing)
  * - document usage (for billing)
  * - external attachments (same banner as in ext and core)
 */

import * as CoreBanners from "app/client/components/CoreBanners";
import { DocUsageBanner } from "app/client/components/DocUsageBanner";
import * as ExtBanners from "app/client/components/ExtBanners";
import { ExternalAttachmentBanner } from "app/client/components/ExternalAttachmentBanner";
import { SiteUsageBanner } from "app/client/components/SiteUsageBanner";
import { SubscriptionBanner } from "app/client/components/SubscriptionBanner";
import { AppModel } from "app/client/models/AppModel";
import { DocPageModel } from "app/client/models/DocPageModel";
import { getGristConfig } from "app/common/urlUtils";

import { dom } from "grainjs";

function buildSassHomeBanners(app: AppModel) {
  return [
    dom.create(SubscriptionBanner, app),
    dom.create(SiteUsageBanner, app),
  ];
}

function buildSassDocumentBanners(docPageModel: DocPageModel) {
  return [
    dom.create(SubscriptionBanner, docPageModel.appModel),
    dom.create(DocUsageBanner, docPageModel),
    dom.create(ExternalAttachmentBanner, docPageModel),
  ];
}

export const buildHomeBanners =
  getGristConfig().deploymentType === "enterprise" ? ExtBanners.buildHomeBanners :
    getGristConfig().deploymentType === "core" ? CoreBanners.buildHomeBanners :
      buildSassHomeBanners;

export const buildDocumentBanners =
  getGristConfig().deploymentType === "enterprise" ? ExtBanners.buildDocumentBanners :
    getGristConfig().deploymentType === "core" ? CoreBanners.buildDocumentBanners :
      buildSassDocumentBanners;
